import React,{useState,useEffect} from 'react';
import { Box, Grid, Text, Tabs, Image, Tab, TabList, TabPanel, TabPanels, Button } from '@chakra-ui/react'
import { Link, Outlet, useNavigate } from 'react-router-dom';
import axios from 'axios';
import {accountsUrl} from '../../Deployed-server-url/deployed-server-url'

function Account(props) {
    const [State, setState] = useState('ACCOUNT')
    const [loginUserArray,setLoginUserArray]=useState([])
    const navigate=useNavigate()
    useEffect(() => {
        axios.get(`${accountsUrl}?login=true`)
        .then((res)=>{
           console.log("make everone logout in accounts page ",res)
           if(res.data.length>0){
            setLoginUserArray(res.data)
            navigate('orders')
           }
           else{
            navigate('/login')
           }
       })
   
    }, [])

    const handleSignout=()=>{
     axios.get(`${accountsUrl}?login=true`)
    .then((res)=>{
        if(res.data.length>0){
            loginUserArray.map((ele)=>{
             ele.login=false
             axios.post(`${accountsUrl}`,{...ele})
             .catch((err)=>{console.log("err after change auth in accounts",err)})
            })
         }
     
    })
    .then(()=>{
        navigate('/login')
    })
     .catch((err)=>{console.log("inAccounts page->",err)})
     
    }

    // useEffect(()=>{
    // if(loginUserArray.length>0){
    //    loginUserArray.map((ele)=>{
    //     ele.login=false
    //     axios.post(`${accountsUrl}`,{...ele})
    //     .catch((err)=>{console.log("err after change auth in accounts",err)})
    //    })
    //    navigate('/')
    // }
    
    // },[loginUserArray])
    
    return (
        <Box  minH={'50vh'} >
            <Box>
               
                <Text textAlign={'left'}>HOME  /  YOUR ACCOUNT  /  {State}</Text>
                <Text mt={'30px'} textAlign={'left'} fontSize={'48px'} color={'black 300'} fontWeight={'20'}>{State}</Text>
            </Box>
            <Grid>
                <Tabs align='center'>
                    <TabList onClick={(e)=>{setState(e.target.innerText)}}>
                        <Tab> <Link to={'orders'}>Orders</Link></Tab>
                        <Tab> <Link to={'returns'}>Returns</Link></Tab>
                        <Tab> <Link to={'messages'}>Messages</Link></Tab>
                        <Tab> <Link to={'addresses'}>Addresses</Link></Tab>
                        <Tab> <Link to={'wishlist'}>Wish List</Link></Tab>
                        <Tab> <Link to={'recentlyviewed'}>Recently Viewed</Link></Tab>
                        <Tab> <Link to={'accountsettings'}>Account Settings</Link></Tab>
                        <Button colorScheme={'telegram'} onClick={handleSignout} > Sign Out</Button>
                    </TabList>
                    <TabPanels>

                    <TabPanel>
                        </TabPanel>
                    </TabPanels>
                </Tabs>
                        <Outlet/>
            </Grid>
        </Box>
    );
}

export default Account;